import React from 'react';
import { useLocation } from 'react-router-dom';
import { COMPANY } from '../legal/company';

// wa.me wants digits only, no "+" or spaces.
const WHATSAPP_NUMBER = COMPANY.phoneHref.replace(/\D/g, '');

/**
 * Floating WhatsApp support button, shown on every page.
 *
 * z-40 keeps it under modals (.nova-modal-overlay is z-50) so it can't sit on
 * top of a dialog the customer is filling in.
 */
const SupportButton: React.FC = () => {
  const { pathname } = useLocation();

  // The page path travels with the message so support knows where the customer
  // was — on /website/:id that includes the website they were editing.
  const message = `Hi OnTheWeb support, I need help.\n\nPage: ${pathname}`;
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with OnTheWeb support on WhatsApp"
      className="fixed bottom-4 right-4 sm:bottom-5 sm:right-5 z-40 flex items-center gap-1.5 sm:gap-2 rounded-full bg-[#25D366] px-3.5 py-2.5 sm:px-4 sm:py-3 text-xs sm:text-sm font-semibold text-white shadow-nova-lg transition-transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-[#25D366]/50"
    >
      <svg viewBox="0 0 24 24" className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" fill="currentColor" aria-hidden>
        <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.92 1.17-.15.2-.3.22-.6.07-.3-.15-1.12-.41-2.14-1.32-.79-.71-1.32-1.58-1.47-1.88-.15-.3-.02-.47.13-.62.15-.15.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.63-.93-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.03 1-1.03 2.45s1.06 2.84 1.21 3.04c.15.2 2.08 3.2 5.04 4.37.7.3 1.25.48 1.68.62.71.22 1.35.19 1.86.12.57-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.12-.27-.2-.57-.35z" />
        <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38c1.45.79 3.08 1.21 4.75 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.92 6.45 17.5 2 12.04 2zm0 18.02h-.01c-1.48 0-2.93-.4-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.13 8.13 0 01-1.25-4.35c0-4.54 3.7-8.23 8.25-8.23 2.2 0 4.27.86 5.82 2.42a8.17 8.17 0 012.41 5.82c0 4.54-3.7 8.2-8.23 8.2z" />
      </svg>
      <span>Need help?</span>
    </a>
  );
};

export default SupportButton;
